import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-bt gfu-bt--b1 _ma-0 _fw-n" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_content_renderer = _resolveComponent("content-renderer")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, {
    nested: "",
    class: "_flexcol _gap-2 _tc--base gfua-help-screen__faq-box"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "_flex _jc-sb _cur-p _ai-c",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.onToggle && $options.onToggle(...args)))
      }, [
        _createElementVNode("h4", _hoisted_1, [
          _createElementVNode("span", {
            innerHTML: $options.highlightedTitle,
            "data-qa": "faq-box-header"
          }, null, 8 /* PROPS */, _hoisted_2)
        ]),
        _createVNode(_component_base_icon, {
          size: "2x",
          name: $options.iconName,
          class: "_tc--accent"
        }, null, 8 /* PROPS */, ["name"])
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_content_renderer, {
          content: $options.highlightedDescription,
          "data-qa": "faq-box-content"
        }, null, 8 /* PROPS */, ["content"]),
        _renderSlot(_ctx.$slots, "default")
      ], 512 /* NEED_PATCH */), [
        [_vShow, !_ctx.isCollapsed]
      ])
    ]),
    _: 3 /* FORWARDED */
  }))
}